/**
 * Will return all product custom questions to be used as options (bottlebooksFieldsSource).
 * @param {object[]} bottlebooksFieldsSource
 * @param {object[]} customProductFields
 * @param {'product' | 'profile'} objectType
 * @returns
 */
export default function mergeCustomQuestions(
  bottlebooksFieldsSource = [],
  customProductFields = [],
  objectType = 'product'
) {
  return customProductFields
    ?.reduce(
      (acc, { label, key, type }) => {
        if (type === 'FILE') return acc;
        if (
          type === 'TEXT' ||
          type === 'YES_NO' ||
          type === 'SELECT' ||
          type === 'IMAGE'
        ) {
          acc.push({
            label,
            key: `${objectType}.companyQuestions.${key}`,
            required: false,
          });
        }
        if (type === 'MULTISELECT') {
          acc.push({
            label,
            key: `${objectType}.companyQuestions.${key}.0.value`,
            required: false,
          });
        }
        console.error(`unhandled type ${type}`);
        return acc;
      },
      [...bottlebooksFieldsSource]
    )
    .sort((a, b) => {
      if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
      if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
      return 0;
    });
}
